import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from '../../../shared/error-boundary';

export default function SignUpButton({ label, signUpUrl }) {
  const signUp = () => (window.location = signUpUrl);

  return (
    <ErrorBoundary>
      <button
        type="button"
        className="btn btn-primary sign-up-button"
        onClick={signUp}
      >
        {label}
      </button>
    </ErrorBoundary>
  );
}

SignUpButton.propTypes = {
  label: PropTypes.string,
  signUpUrl: PropTypes.string,
};

SignUpButton.defaultProps = {
  label: 'Join Free',
  signUpUrl: '/sign_up',
};
